import React, { useMemo, useCallback } from 'react';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { formatDateTimeForKstInput } from '../utils/time';

interface DateTime24PickerProps {
  value?: string;
  onChange?: (nextValue: string | null) => void;
  disabled?: boolean;
  dateLabel?: string;
  className?: string;
  inputClassName?: string;
}

const DateTime24Picker: React.FC<DateTime24PickerProps> = ({
  value,
  onChange,
  disabled = false,
  dateLabel,
  className,
  inputClassName,
}) => {
  const selectedDate = useMemo(() => {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }, [value]);

  
const handleChange = useCallback(
  (next: Date | null) => {
    if (!next) {
      onChange?.(null);
      return;
    }
    onChange?.(formatDateTimeForKstInput(next));
  },
  [onChange],
);

  return (
    <div className={className}>
      {dateLabel && (
        <label className="block text-xs text-gray-400 mb-1">{dateLabel}</label>
      )}
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateTimePicker
          value={selectedDate}
          onChange={handleChange}
          ampm={false}
          format="yyyy-MM-dd HH:mm"
          disabled={disabled}
          enableAccessibleFieldDOMStructure={false}
          slots={{ textField: TextField }}
          slotProps={{
            textField: {
              className: `w-[275px] px-3 py-2 bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed ${inputClassName || ''}`,
              size: 'small',
              variant: 'outlined',
              InputProps: {
                sx: {
                  color: '#fff',
                  '& .MuiInputBase-input': {
                    color: '#fff',
                  },
                },
              },
              InputLabelProps: {
                sx: {
                  color: '#9ca3af',
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default DateTime24Picker;
